<template>
    <div class="tb_st03 mt-10 pc-visible">
        <div class="thead">
            <table>
                <caption>리스트헤더</caption>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                </colgroup>
                <thead>
                <tr>
                    <th>일자</th>
                    <th>사고</th>
                    <th>공사</th>
                    <th>행사</th>
                    <th>통제</th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="tbody full scroll">
            <table>
                <caption>리스트내용</caption>
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                </colgroup>
                <thead style="display: none;">
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="accident in accidentGroupList">
                        <td>{{ getDate(accident.basdtVal) }}</td>
                        <td>{{ accident['1'] }}건</td>
                        <td>{{ accident['2'] }}건</td>
                        <td>{{ accident['3'] }}건</td>
                        <td>{{ accident['5'] }}건</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";

export default {
    computed: {
        ...mapGetters({
            accidentGroupList: 'getAccidentGroupList',
        }),
    },
    methods: {
        getDate(val) {
            return gripUtil.formatDate(val, "yyyy-MM-dd",);
        },
    },
};
</script>
